<template>
  <div class="navbar">
    <div class="goback" @click="routerTo" style="cursor: pointer;">
      <svg-icon icon-class="logo"/>
        <!-- <img src="@/assets/images/portal/logo@52.png" alt="" title="返回首页" @click="routerTo" style="cursor: pointer;"> -->
    </div>
    <div class="header-tab">
        <div class="tabitem" :class="{'active':position === 1}" label="simple1" @click="toSim(1)">
            <a href="#" class="Preference">精品实验
                <!-- <svg-icon icon-class="myex" style="float:left;" /> -->
            </a>
        </div>
        <div class="tabitem" :class="{'active':position === 2}" label="simple2" @click="toSim(2)">
            <a href="#" class="Preference">同步实验
                <!-- <svg-icon icon-class="myex" style="float:left;" /> -->
            </a>
        </div>
        <div class="tabitem" :class="{'active':position === 3}" label="simple3" @click="toSim(3)">
            <a href="#" class="Preference">探究实验
                <!-- <svg-icon icon-class="myex" style="float:left;" /> -->
            </a>
        </div>
        <div style="width:1px;height:24px;background-color:#EFDBCC;float:left;margin-top:18px;" v-if="this.position != 4"></div>
        <div class="tabitem" :class="{'active':position === 4}" label="simple4" @click="toSim(4)">
            <a href="#" class="Preference">我的实验
                <!-- <svg-icon icon-class="myex" style="float:left;" /> -->
            </a>
        </div>
        <div class="tabitem" :class="{'active':position === 5}" label="simple5" @click="toSim(5)">
            <a href="#" class="Preference">回收站</a>
        </div>
        <div class="tabitem" @click="entrance" v-if="this.isShowE == 1">
            <a href="#" class="Preference">数理化综合实践二轮活动</a>
        </div>
    </div>
    <breadcrumb class="breadcrumb-container"/>
    <!-- <div class="contact">
      <ul>
        <li><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3235186608&site=qq&menu=yes">商务QQ:3235186608</a></li>
        <li><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3512883254&site=qq&menu=yes">产品QQ:3512883254</a></li>
      </ul>
    </div> -->
    <!-- 国际化 -->
    <div class="contact" style="color:#f8d3c0;margin-right:20px;cursor: pointer;" v-if="isShowLang">
      <el-dropdown trigger="click" class="lang-dropdown">
        <span class="el-dropdown-link">{{this.lang}}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item,index) in langChoice" :key="index" @click.native="langChoiceOne(item)">{{item.value}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="right-menu">
      <!-- <template v-if="device!=='mobile'">
        <el-tooltip content="全屏" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item"/>
        </el-tooltip>
      </template> -->
      <el-dropdown class="avatar-container right-menu-item" trigger="hover">
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar">
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>
              回到首页
            </el-dropdown-item>
          </router-link>
          <router-link to="/personal">
            <el-dropdown-item>
              <span>个人中心</span>
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item>
            <span @click="openExternal">联系客服</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Screenfull from '@/components/Screenfull'
import request from '@/utils/request'


export default {
  components: {
    Breadcrumb,
    Screenfull
  },
  computed: {
    ...mapGetters([
      // 'sidebar',
      'avatar',
      'device',
    ])
  },
  // 跳转首页刷新页面
  inject:['reload'],
  data(){
    return {
      isShowLang:false,
      lang:'简体中文',
      langChoice:[{
        value:'简体中文',
        label:'zh'
      },{
        value:'English',
        label:'en'
      }],
      isShowE:'',
      position:4,
      opened:true,
    }
  },
  created(){
    this.getinfo();
  },
  methods: {
    // 语言选择
    langChoiceOne(item){
      if(item.label == 'en'){
        this.lang = 'English'
        this.$i18n.locale = 'en'
        localStorage.setItem('language','en')
        this.$router.push({path:'/en'})
        this.reload();
        document.getElementById('titleId').innerHTML = 'VReaLab'
      }else if(item.label == 'zh'){
        this.lang = '简体中文'
        this.$i18n.locale = 'zh'
        localStorage.setItem('language','zh')
        document.getElementById('titleId').innerHTML = '矩道理科实验平台'
      }
    },
    //获取info
    getinfo(){
      if(localStorage.getItem('language') == 'en'){
        this.lang = 'English'
      }else if(localStorage.getItem('language') == 'zh'){
        this.lang = '简体中文'
      }
      if(localStorage.getItem('langEn') == ''){
        this.isShowLang = true;
      }else if(localStorage.getItem('langEn') == 'en'){
        this.isShowLang = false;
      }else if(localStorage.getItem('langEn') == 'zh'){
        this.isShowLang = false;
      }
      request({
        method:'get',
        url:'auth/info'
      }).then(res=>{
        this.isShowE = res.jwtUser.activity
      })
    },
    // 活动入口
    entrance(){
      // 生产
      window.open("http://wulidasai.judaoedu.com/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
      // 测试
      // window.open("http://221.231.139.161:8011/ScienceMatch/AuthLogin.html?token="+this.$store.state.user.token,"_blank")
    },
    openExternal(){
      window.open("http://wpa.qq.com/msgrd?v=3&uin=3512883254&site=qq&menu=yes","_blank")
    },
    toSim(index){
      if(index == 1){
        this.$router.push({path:'/'})
        // this.switchs = '全部'
      }else if(index == 2){
        this.$router.push({path:'/synchronization'})
        // this.switchs = '同步'
      }else if(index == 3){
        this.$router.push({path:'/explore'})
        // this.switchs = '探究'
      }else if(index == 4){
        
      }else if(index == 5){
        this.$router.push({path:'/recycle'})
      }
    },
    // 跳转首页刷新页面
    routerTo(){
      window.open("http://www.judaoedu.com/");
      // this.$router.push({path:'/'});
      // this.reload();
    },
    toggleSideBar() {
      // this.$store.dispatch('ToggleSideBar')
      this.opened=!this.opened
    },
    logout() {
      if(localStorage.getItem('language') == 'en'){
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index'});
          localStorage.setItem('language','en');
        }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index?lan=en'})
        }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index?lan=zh'})
        }
      }else if(localStorage.getItem('language') == 'zh'){
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index'});
        }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
          this.$router.push({path:'/index?lan=en'})
        }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
          this.$router.push({path:'/index?lan=zh'})
        }
      }
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.lang-dropdown{
  color: #f8d3c0;
}
.lang-dropdown:hover{
  color: #fff;
}
  @media screen and (min-width:769px) and (max-width: 1024px){
    .ques{
      display: none;
    }
  }
.goback{
  margin-left: 20px;
  height: 100%;
  float: left;
  width: 166px;
}
.switch{
  width: 50px;
  height: 100%;
  float: left;
  line-height: 60px;
}
.switch /deep/ .el-input__suffix{
  display: none;
}
.switch /deep/ .el-input--suffix .el-input__inner{
  padding: 0 10px;
  height: 30px;
  border-radius: 20px;
  border-color: #F38F38 ;
  background-color: rgba(233, 238, 242, .4);
  color: rgb(240, 234, 234);
}
.svg-icon{
  width: 100% !important;
  height: 100% !important;
  padding-top: 2px;
  padding-bottom: 2px;
}
.header-tab{
  height: 100%;
  float: left;
  line-height: 60px;
  margin-left:50px;
  .tabitem{
    float:left;
    padding: 0 20px;
    color: #f8d3c0;
    cursor: pointer;
    font-size: 18px;
  }
  .tabitem:hover{
    // background-color: #fef7ed;
    color: #fff ;
  }
  .active{
    background-color: #fef7ed;
    color: #ec6f28 ;
  }
  .active:hover{
    background-color: #fef7ed;
    color: #ec6f28 ;
  }
}
// .goback img{
//   width: 120px;
//   height: 46px;
//   margin-top: 7px;
// }
.goback img{
  // width: 120px;
  // height: 46px;
  margin-top: 4px;
}
  .navbar {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2000;
    height: 60px;
    background: linear-gradient(to right, rgb(241, 152, 73) 10%, rgb(236, 111, 40) 100%);
    border-bottom: 1px solid #f1ad4e;
    border-radius: 0px !important;
    .hamburger-container {
      line-height: 58px;
      height: 60px;
      float: left;
      padding: 0 10px;
    }
   .app-breadcrumb.el-breadcrumb{
     display: none;
   }
    .breadcrumb-container{
      float: left;
    }
    .errLog-container {
      display: inline-block;
      vertical-align: top;
    }
    .right-menu {
      float: right;
      height: 100%;
      &:focus{
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international{
        vertical-align: top;
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        height: 60px;
        margin-right: 30px;
        .avatar-wrapper {
          margin-top: 9px;
          position: relative;
          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
.contact{
  position: absolute;
  right: 6%;
  top: 50%;
  transform: translateY(-50%);
}
.contact ul{
  list-style: none;
  margin: 0;
  padding: 0;
}
.contact ul li{
  color: #fff;
  border-right: 1px solid #eee;
  float:left;
  padding-right:5px;
  font-size: 12px;
}
.contact ul li:last-of-type{
  padding-left:5px;
  padding-right:none;
  border-right:none;
}
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #fef7ed;
    color: #F38F38;
  }
  // .el-select-dropdown{
  //   margin-top: -8px !important;
  //   left: 170px !important;
  // }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color:#fef7ed;
  }
  .el-select-dropdown__item.selected{
    color: #F38F38;
  }
@media (max-width: 1024px){
  .header-tab{
    margin-left: 20px;
  }
  .header-tab .tabitem{
    padding: 0 10px;
    font-size: 16px;
  }
  .goback{
    margin-left: 0;
    height: 100%;
    float: left;
    width: 166px;
  }
  .contact{
    right: 7%;
  }
  .contact /deep/ .el-dropdown{
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/NavbarM.vue